import React, { useState, useEffect } from 'react';
import { callPublicApi, callApi } from '../api';
import { ALL_NAV_ITEMS } from '../components/BottomNav';
import './YonetimSayfasi.css';

const Ayarlar = ({ hasPerm, isSuperAdmin, user }) => {
    const canEditSettings = isSuperAdmin || (hasPerm && hasPerm('ayarlar'));

    // Bottom Nav Preferences
    const [navPrefs, setNavPrefs] = useState(() => {
        const prefKey = (user && (user.username || user.id)) ? `bottomNavPrefs_${user.username || user.id}` : 'bottomNavPrefs';
        try {
            const saved = localStorage.getItem(prefKey);
            if (saved) {
                const parsed = JSON.parse(saved);
                if (Array.isArray(parsed)) {
                    if (!parsed.includes('ayarlar')) parsed.push('ayarlar');
                    return parsed;
                }
            }
        } catch (e) {
            console.error("Parse Error LocalStorage:", e);
            localStorage.removeItem(prefKey);
        }
        return ['dashboard', 'etkinlikler', 'basvurular', 'ayarlar'];
    });

    const toggleNavItem = (key) => {
        if (key === 'ayarlar') return; // Cannot toggle Ayarlar

        setNavPrefs(prev => {
            if (prev.includes(key)) {
                return prev.filter(k => k !== key);
            }
            if (prev.length >= 4) return prev; // Max 4 (excluding FAB center)
            return [...prev, key];
        });
    };

    const saveNavPrefs = () => {
        const prefKey = (user && (user.username || user.id)) ? `bottomNavPrefs_${user.username || user.id}` : 'bottomNavPrefs';
        localStorage.setItem(prefKey, JSON.stringify(navPrefs));
        setMessage('Alt navigasyon tercihleri kaydedildi!');
    };

    // Filter nav items by permission
    const availableNavItems = ALL_NAV_ITEMS.filter(item => {
        if (item.perm === null) return true;
        if (isSuperAdmin) return true;
        if (hasPerm) return hasPerm(item.perm);
        return false;
    });
    const [kulup, setKulup] = useState({
        kulupID: 'klugastro', // Varsayılan
        ad: '',
        logoURL: '',
        bannerURL: '',
        temaRengi: '#ff6600', // Varsayılan turuncu
        baskanEmail: ''
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [message, setMessage] = useState('');

    // Verileri Çek
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Get Current Club ID from Storage (set by App.js)
                const currentClubID = localStorage.getItem('selectedClubID') || 'klugastro';

                // Fetch SPECIFIC club data
                // Backend supports GET /kulupler?id=...
                const data = await callPublicApi(`/kulupler?id=${currentClubID}`);

                if (data.item) {
                    setKulup(data.item);
                } else if (data.items && data.items.length > 0) {
                    // Fallback if API behaves differently
                    setKulup(data.items[0]);
                } else {
                    console.log("Kulüp bulunamadı.");
                }
            } catch (err) {
                console.error("Veri çekme hatası:", err);
                setMessage('Hata: Kulüp bilgileri yüklenemedi.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleChange = (e) => {
        setKulup({ ...kulup, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setMessage('');

        try {
            // PUT /kulupler ile güncelle/oluştur
            await callApi('/kulupler', 'PUT', kulup);
            setMessage('Başarılı: Kulüp profili güncellendi!');
        } catch (err) {
            console.error("Kaydetme hatası:", err);
            setMessage('Hata: ' + err.message);
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) return <div className="loading-state">Kulüp Profili Yükleniyor...</div>;

    return (
        <div className="yonetim-sayfasi">
            <div className="header-flex">
                <h2>Kulüp Profili & Ayarlar</h2>
                {/* Önizleme Rozeti */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#fff', padding: '5px 15px', borderRadius: '20px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
                    <span style={{ fontSize: '0.8rem', color: '#666' }}>Tema Önizleme:</span>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: kulup.temaRengi, border: '2px solid #ddd' }}></div>
                </div>
            </div>

            {message && <p className={`message ${message.startsWith('Hata') ? 'error-message' : 'success-message'}`}>{message}</p>}

            {!canEditSettings && (
                <div style={{ background: '#fff3cd', color: '#856404', padding: '15px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #ffeeba' }}>
                    <strong>Yetki Sınırı:</strong> Kulüp genel ayarlarını, tema renklerini ve sistem kimliğini düzenleme yetkiniz bulunmuyor. Ancak hesap tercihleriniz kapsamında <strong>Mobil Navigasyon Düzeni</strong>'ni özelleştirebilirsiniz.
                </div>
            )}

            {canEditSettings && (
            <form onSubmit={handleSubmit} className="ayarlar-formu">
                {/* 1. KULÜP KİMLİĞİ */}
                <div className="form-section-group">
                    <h3>Kulüp Kimliği</h3>

                    <label>Kulüp Adı</label>
                    <input
                        type="text"
                        name="ad"
                        placeholder="Örn: KLU Gastronomi Kulübü"
                        value={kulup.ad}
                        onChange={handleChange}
                        required
                    />

                    <div className="form-row-2">
                        <div>
                            <label>Logo URL</label>
                            <input
                                type="text"
                                name="logoURL"
                                placeholder="Logo Resim Linki"
                                value={kulup.logoURL}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label>Logo Önizleme</label>
                            <div className="image-preview-box">
                                {kulup.logoURL ? <img src={kulup.logoURL} alt="Logo" /> : 'Görsel Yok'}
                            </div>
                        </div>
                    </div>

                    <div className="form-row-2">
                        <div>
                            <label>Banner URL (Kapak)</label>
                            <input
                                type="text"
                                name="bannerURL"
                                placeholder="Kapak Resmi Linki"
                                value={kulup.bannerURL}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label>Banner Önizleme</label>
                            <div className="image-preview-box horizontal">
                                {kulup.bannerURL ? <img src={kulup.bannerURL} alt="Banner" /> : 'Görsel Yok'}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. GÖRÜNÜM & İLETİŞİM */}
                <div className="form-section-group">
                    <h3>Görünüm & İletişim</h3>

                    <label>Tema Rengi (Web Sitesi Ana Rengi)</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input
                            type="color"
                            name="temaRengi"
                            value={kulup.temaRengi}
                            onChange={handleChange}
                            style={{ width: '60px', height: '40px', padding: 0, border: 'none', cursor: 'pointer' }}
                        />
                        <span style={{ color: '#666' }}>{kulup.temaRengi}</span>
                    </div>

                    <br />

                    <label>Başkan E-posta (İletişim)</label>
                    <input
                        type="email"
                        name="baskanEmail"
                        placeholder="baskan@kulup.com"
                        value={kulup.baskanEmail}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-actions">
                    <button type="submit" disabled={isSaving}>
                        {isSaving ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet'}
                    </button>
                </div>
            </form>
            )}

            {/* 3. MOBİL NAVİGASYON TERCİHLERİ */}
            <div className="form-section-group" style={{ marginTop: '24px' }}>
                <h3>📱 Mobil Navigasyon Tercihleri</h3>
                <p style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '16px' }}>
                    Mobil ekranda alt menüde görmek istediğin sayfaları seç (Ayarlar sabit, en fazla 3 ekstra).
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                    {availableNavItems.map(item => (
                        <label
                            key={item.key}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '10px 14px',
                                background: navPrefs.includes(item.key) ? 'rgba(99,102,241,0.08)' : '#f8fafc',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                border: navPrefs.includes(item.key) ? '1.5px solid #6366f1' : '1.5px solid #e2e8f0',
                                transition: 'all 0.15s ease',
                                fontWeight: navPrefs.includes(item.key) ? 600 : 400,
                                color: navPrefs.includes(item.key) ? '#4f46e5' : '#64748b'
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={navPrefs.includes(item.key) || item.key === 'ayarlar'}
                                onChange={() => toggleNavItem(item.key)}
                                disabled={(item.key === 'ayarlar') || (!navPrefs.includes(item.key) && navPrefs.length >= 4)}
                                style={{ accentColor: '#6366f1', width: '18px', height: '18px', opacity: item.key === 'ayarlar' ? 0.5 : 1 }}
                            />
                            <span style={{ fontSize: '16px' }}>{item.icon}</span>
                            <span style={{ fontSize: '0.9rem' }}>{item.label}</span>
                            {navPrefs.includes(item.key) && (
                                <span style={{
                                    marginLeft: 'auto',
                                    fontSize: '0.7rem',
                                    background: '#6366f1',
                                    color: 'white',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontWeight: 700
                                }}>
                                    #{navPrefs.indexOf(item.key) + 1}
                                </span>
                            )}
                        </label>
                    ))}
                </div>

                {/* Preview Strip */}
                <div style={{ marginBottom: '16px' }}>
                    <p style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em', marginBottom: '8px' }}>
                        Önizleme
                    </p>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        background: 'var(--bg-card)',
                        borderRadius: '16px',
                        padding: '10px 8px',
                        maxWidth: '360px',
                        border: '1px solid var(--border-color)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                    }}>
                        {navPrefs.slice(0, 4).map(key => {
                            const item = ALL_NAV_ITEMS.find(i => i.key === key);
                            if (!item) return null;
                            return (
                                <div key={key} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '2px',
                                    color: 'var(--text-secondary)',
                                    fontSize: '0.6rem',
                                    fontWeight: 600,
                                    minWidth: '48px'
                                }}>
                                    <span style={{ fontSize: '18px' }}>{item.icon}</span>
                                    <span>{item.label}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <button
                    type="button"
                    onClick={saveNavPrefs}
                    style={{
                        background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                        color: 'white',
                        border: 'none',
                        padding: '10px 24px',
                        borderRadius: '8px',
                        fontWeight: 600,
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                        boxShadow: '0 4px 14px rgba(99,102,241,0.25)'
                    }}
                >
                    Navigasyon Tercihlerini Kaydet
                </button>
            </div>
        </div>
    );
};

export default Ayarlar;
